export const FETCH_CONFIGURATION_STARTED = 'FETCH_CONFIGURATION_STARTED';
export const FETCH_CONFIGURATION_SUCCEEDED = 'FETCH_CONFIGURATION_SUCCEEDED';
export const FETCH_CONFIGURATION_FAILED = 'FETCH_CONFIGURATION_FAILED';

export const FETCH_CONFIGURATIONS_STARTED = 'FETCH_CONFIGURATIONS_STARTED';
export const FETCH_CONFIGURATIONS_SUCCEEDED = 'FETCH_CONFIGURATIONS_SUCCEEDED';
export const FETCH_CONFIGURATIONS_FAILED = 'FETCH_CONFIGURATIONS_FAILED';

export const CONFIGURATION_SET = 'CONFIGURATION_SET';

// theme
export const PRIMARY_COLOR_SET = 'PRIMARY_COLOR_SET';
export const THEME_VARIANT_SET = 'THEME_VARIANT_SET';
